import { action, observable } from 'mobx';
import DeviceStore from '@/stores/device';
import * as R from 'ramda';
import { getDeviceToken } from '@/services/Home';

class DeviceModalStore {

    @observable.ref deviceData: any;
    @observable.ref mask: string = 'hidden';
    @observable.ref setList: string = 'hidden';
    @observable.ref coludStatus: string = 'fail';

    @observable.ref sizeType: string;
    @observable.ref rotateType: string;

    @observable.ref accessKeyId: string;
    @observable.ref masterId: string;
    @observable.ref cap: string;
    @observable.ref packageName: string;
    @observable.ref token: string;
    @observable.ref slaveIds: any[] = [];
    @observable.ref cloudPlay: any;

    @action.bound setSizeType(type: string) {
        window.localStorage.setItem('sizeTypeSingle', type);
        this.sizeType = type
    }

    @action.bound setRotateType(type: string) {
        window.localStorage.setItem('rotateTypeSingle', type);
        this.rotateType = type
    }

    @action.bound async initCloud(value: string) {
        this.deviceData = R.find(R.propEq('cid', value))(DeviceStore.DeviceBaseStore.deviceList)

        //获取云机同步token
        const [error, result] = await getDeviceToken({ serviceId: this.deviceData.id });
        if (error) return;
        this.accessKeyId = result.cid;
        this.masterId = this.deviceData.cid;
        this.packageName = result.packageName;
        this.cap = '0.50';
        this.token = result.accessToken;
        this.slaveIds = [{
            phoneId: this.deviceData.cid,
            domId: this.deviceData.cid
        }]
    }
}

export default DeviceModalStore;
